<template>
  <div class="progress-loading">
    <div class="progress">
      <el-progress  :percentage="percentage" :color="customColor"></el-progress>
    </div>
    <p class="info">
      Loading results from {{ getRest }}+ China airports for offering you the best solution.
    </p>
  </div>

</template>

<script>
export default {
  // props: {
  //   startLoading: {
  //     type: Number,
  //     required: false,
  //     default: 0
  //   }
  // },
  data() {
    return {
      percentage: 0, // 进度百分比
      customColor: '#004FB1',
      timer: null,
    }
  },
  computed: {
    getRest() {
      if (this.percentage < 99) {
        return 100 - this.percentage;
      } else {
        return 1;
      }
    }
  },
  mounted() {
    this.timer = setInterval(this.addPercentage, 500)
  },
  methods: {
    addPercentage() {
      if (this.percentage < 99) {
        this.percentage += 16.5;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
</script>

<style lang="less">
.progress-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .progress {
    width: 300px;
    .el-progress-bar__outer {
      background-color: #e2e2e2;
    }
  }

  .info {
    margin-top: 20px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #9B9B9B;
    line-height: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reception/public/progressLoading.vue